import { useLocation } from "react-router-dom"
import { useIsMobile } from "@/hooks/useIsMobile"

interface BackgroundLayerProps {
  showBackground: boolean
  isDashboardRoute: boolean
  isAltRoute: boolean
  isCreateOrEditRoute: boolean
  backgroundImage: string
}

export function BackgroundLayer({
  showBackground,
  isDashboardRoute,
  isAltRoute,
  isCreateOrEditRoute,
  backgroundImage,
}: BackgroundLayerProps) {
  const { pathname } = useLocation()
  const isMobile = useIsMobile()
  const isMyRitualityRoute = pathname === "/my-rituality"

  if (!showBackground) return null

  const bgClass = isDashboardRoute
    ? "bg-cover bg-no-repeat bg-center md:bg-[position:185%]"
    : isCreateOrEditRoute
      ? "bg-cover bg-no-repeat bg-[position:center_1%]"
      : "bg-cover md:bg-[length:150%_100%] bg-no-repeat bg-center md:bg-[position:185%]"

  return (
    <div
      className={`absolute top-0 left-0 right-0 ${isMyRitualityRoute ? "h-210" : "h-122.75"} -z-10 w-full ${bgClass}`}
      style={{
        backgroundImage: `url(${backgroundImage})`,
      }}
    >
      {isDashboardRoute && (
        <div
          className="absolute inset-0"
          style={{
            background: "linear-gradient(180deg, rgba(2, 2, 2, 0.27) 0%, #020202 100%)",
          }}
        />
      )}

      <div
        className="absolute inset-0"
        style={{ background: "linear-gradient(180deg, rgba(2, 2, 2, 0) 0%, #020202 100%)" }}
      />

      {isAltRoute && !isMobile && (
        <div
          className="absolute inset-0 backdrop-blur-2xl"
          style={{
            background:
              "linear-gradient(180deg, rgba(2, 2, 2, 0.6) 100%, #020202 100%, #020202 100%)",
          }}
        />
      )}
    </div>
  )
}
